import { Component, OnInit } from '@angular/core';
import { LoginUnawareComponent } from '../login-unaware-component';
import { GraphClientService } from '../services/graph-client-service';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

/**
 * Carousel of social posts. A wrapper around swiper-slider component,
 * this component is responsible for loading a list of cards metadata
 * from a SharePoint list, and providing a rendering template for a card.
 * Images are not stored in Office 365, as anonymous access to them would get blocked.
 */
@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.scss']
})
export class SocialMediaComponent extends LoginUnawareComponent implements OnInit {
  public items: Array<any>;

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService) {
    super(diagnosticsFactory.create('SocialMediaComponent'));
   }

  ngOnInit() {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
        const dynamicData = data as any;
        const dataItems: Array<any> = dynamicData.value;
        dataItems.sort((left, right) => left.fields.SortOrder - right.fields.SortOrder);
        this.items = dataItems;
      }, error => {
        this.diagnostics.logError(`Error loading data. Details: ${JSON.stringify(error)}`);
      });
  }
}
